'use client'

import {ElementType, ReactNode, forwardRef} from 'react'

import {cx} from '@local/utils/cx'
import {ScrollOffset} from '@local/hooks/useScrollRatio'
import {ScrollAnimationProps, ScrollAnimation} from '@local/ui/components'

export interface ParallaxProps {
	children: ReactNode
	distance?: number
	useViewportRatio?: boolean
	scrollProps?: ScrollAnimationProps
	as?: ElementType
	className?: string
	childClassName?: string
	offset?: ScrollOffset
	clip?: boolean
	fullHeight?: boolean
	fullInnerHeight?: boolean
}

export const ParallaxMedia = forwardRef(
	(
		{
			as = 'div',
			distance = 100,
			useViewportRatio = false,
			clip = true,
			offset = [[0.5, 0.5], [1, 0]],
			children,
			scrollProps = {},
			className,
			childClassName,
			fullHeight = false,
			fullInnerHeight = false,
			...rest
		}: ParallaxProps,
		ref,
	) => {
		const Tag = as

		return (
			<Tag {...rest} ref={ref} className={cx(fullHeight && 'h-full', className, clip && 'overflow-clip')}>
				<ScrollAnimation
					className={cx((fullHeight || fullInnerHeight) && 'h-full', childClassName)}
					{...scrollProps}
					y={distance}
					useViewportRatio={useViewportRatio}
					offset={offset}
					scaleToFit>
					{children}
				</ScrollAnimation>
			</Tag>
		)
	},
)
